/**
 * Zamienia znaczniki [tabela-opis]...[/tabela-opis] w rich text metapól na HTML <table>.
 *
 * Format w metapolu (rich text):
 *   [tabela-opis]
 *   Typ | Modele | Wymiary
 *   Zawieszka | A, B | 10 mm
 *   Pierścionek | C | 5 mm
 *   [/tabela-opis]
 *
 * Kolumny: |   Wiersze: nowa linia / Enter
 * Pierwszy wiersz = nagłówek (th).
 */
(function () {
  var OPEN = '[tabela-opis]';
  var CLOSE = '[/tabela-opis]';
  var FIELD_SELECTOR = '.metafield-rich_text_field';

  function decodeEntities(text) {
    var el = document.createElement('textarea');
    el.innerHTML = text;
    return el.value;
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function contentToRows(rawHtml) {
    var text = rawHtml
      .replace(/<\/p>\s*<p[^>]*>/gi, '\n')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/?p[^>]*>/gi, '\n')
      .replace(/<\/?(div|span|strong|em|b|i|u)[^>]*>/gi, '')
      .replace(/<[^>]+>/g, '')
      .replace(/\u00a0/g, ' ');

    text = decodeEntities(text);

    return text
      .split(/\r?\n/)
      .map(function (line) {
        return line.trim();
      })
      .filter(function (line) {
        return line.length > 0;
      });
  }

  function rowsToTable(rows) {
    if (!rows.length) return '';

    var html = '<div class="table-wrapper tabela-opis-wrapper"><table class="table table--bordered tabela-opis">';

    rows.forEach(function (row, index) {
      var cells = row.split('|').map(function (cell) {
        return cell.trim();
      });
      var tag = index === 0 ? 'th' : 'td';

      if (index === 0) html += '<thead>';
      if (index === 1) html += '<tbody>';

      html += '<tr>';
      cells.forEach(function (cell) {
        html += '<' + tag + '>' + escapeHtml(cell) + '</' + tag + '>';
      });
      html += '</tr>';

      if (index === 0) html += '</thead>';
    });

    if (rows.length > 1) html += '</tbody>';
    html += '</table></div>';
    return html;
  }

  function replaceMarkers(html) {
    var lower = html.toLowerCase();
    var openLower = OPEN.toLowerCase();
    var closeLower = CLOSE.toLowerCase();
    var result = '';
    var cursor = 0;

    while (cursor < html.length) {
      var start = lower.indexOf(openLower, cursor);
      if (start === -1) {
        result += html.slice(cursor);
        break;
      }

      var contentStart = start + OPEN.length;
      var end = lower.indexOf(closeLower, contentStart);
      if (end === -1) {
        result += html.slice(cursor);
        break;
      }

      result += html.slice(cursor, start);
      result += rowsToTable(contentToRows(html.slice(contentStart, end)));
      cursor = end + CLOSE.length;
    }

    return result
      .replace(/<p[^>]*>\s*(<div class="table-wrapper tabela-opis-wrapper">[\s\S]*?<\/div>)\s*<\/p>/gi, '$1')
      .replace(/<p[^>]*>\s*<\/p>/gi, '');
  }

  function processField(field) {
    if (!field || field.getAttribute('data-tabela-opis-done') === '1') return;
    if (field.innerHTML.toLowerCase().indexOf(OPEN.toLowerCase()) === -1) return;

    field.innerHTML = replaceMarkers(field.innerHTML);
    field.setAttribute('data-tabela-opis-done', '1');
  }

  function processAll() {
    document.querySelectorAll(FIELD_SELECTOR).forEach(processField);
  }

  // defer: DOM jest gotowy przed DOMContentLoaded — konwersja przed skryptem „Rozwiń”
  processAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  }

  window.IcedTabelaOpis = { processAll: processAll, processField: processField };
})();
